import React from 'react';

import { ButtonProps } from 'antd/lib/button';

import * as Styled from './Button.style';

export type Props = ButtonProps;

export const Button = (props: Props): JSX.Element => <Styled.Button {...props} />;
